import { Moment } from 'moment';
import { FC } from 'react';

interface Props {
  time: Moment;
  from?: Moment;
  noSuffix?: boolean;
}

export const RelativeTime: FC<React.PropsWithChildren<Props>> = ({
  time,
  from,
  noSuffix,
}) => (
  <>{from == null ? time.fromNow(!!noSuffix) : time.from(from, !noSuffix)}</>
);
